// extracted by mini-css-extract-plugin
export default {"google-fonts-modal":"styles_google-fonts-modal__0b0mE"};